import React from "react";
import { Link } from "react-router-dom";

const HeaderImg = ({ title }) => {
  return (
    <div className="headerImg">
      <div className="headerImg__main">
        <h2>{title}</h2>
        <div className="headerImg__main__linkCon">
          <Link to="/">Home</Link> / {title}
        </div>
      </div>
    </div>
  );
};

export default HeaderImg;
